import { PageViewData } from './BaseTrackingService';
import { MixPanelTrackerService } from './MixPanelTrackerService';
import { PostHogTrackerService } from './PostHogTrackerService';

export type Properties = {
    [x: string]: any;
};

/** `beacon`: skip the queue and send by `navigator.sendBeacon`, for an event sent while the page is going away. */
export type TrackOptions = {
    beacon?: boolean;
};

export class StackTrackerService implements TrackerService {
    private posthogTracker: PostHogTrackerService;
    private mixPanelTracker: MixPanelTrackerService;

    constructor(posthogTracker: PostHogTrackerService, mixPanelTracker: MixPanelTrackerService) {
        this.posthogTracker = posthogTracker;
        this.mixPanelTracker = mixPanelTracker;
    }

    pageView(properties?: PageViewData): void {
        this.posthogTracker.pageView(properties);
        this.mixPanelTracker.pageView(properties);
    }

    track(event: string, properties?: Properties, options?: TrackOptions): void {
        this.posthogTracker.track(event, properties, options);
        this.mixPanelTracker.track(event, properties, options);
    }

    identify(userId: string, properties?: Properties): void {
        this.posthogTracker.identify(userId, properties);
        this.mixPanelTracker.identify(userId, properties);
    }

    setPersonProperties(properties: Properties): void {
        this.posthogTracker.setPersonProperties(properties);
        this.mixPanelTracker.setPersonProperties(properties);
    }

    group(type: string, key: string, properties?: Properties): void {
        this.posthogTracker.group(type, key, properties);
        this.mixPanelTracker.group(type, key, properties);
    }

    captureException(error: unknown, properties?: Properties): void {
        this.posthogTracker.captureException(error, properties);
        this.mixPanelTracker.captureException(error, properties);
    }

    reset(): void {
        this.posthogTracker.reset();
        this.mixPanelTracker.reset();
    }
}
